import styled from '@emotion/styled'
import { typography, colors } from '@resiliatech/birdsong'
import { ReactComponent as Chart } from './example.svg'

export const Container = styled.div`
  margin: auto;
  margin-top: 20px;
  margin-bottom: 10px;
  width: 538px;
  height: 196px;
  padding: 16px;
  background: ${colors.background.primaryBackground};
`

export const Title = styled.span`
  ${typography.down1.regularSansItalic};
  color: ${colors.copy.paragraphDark};
`

export const ChartImage = styled(Chart)`
  margin-top: 16px;
`
